import styled, { css } from 'styled-components'
import { Container } from '~/shared/components/Container'
import { Option } from '~/shared/components/Option'
import { BREAKPOINTS, COLORS } from '~/shared/constants/uiConstants'

export const Styles = {
  Root: styled.div`
    position: relative;
    width: 100%;
    height: calc(100dvh - var(--header-height));

    &::before {
      position: absolute;
      z-index: -1;
      inset: 0;
      top: calc(-1 * var(--header-height));
      content: '';
      background-color: ${COLORS.GRAY_100};
    }
  `,

  StyledContainer: styled(Container)`
    height: 100%;
    display: flex;
    flex-direction: column;
    padding: 16px 16px 24px;
    min-height: 0;
  `,

  ScrollContent: styled.div`
    flex: 1;
    min-height: 0;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    height: 100%;
  `,

  Title: styled.h1`
    font-size: 22px;
    font-weight: 700;
    line-height: 24px;
    color: ${COLORS.BLACK};
  `,

  Subtitle: styled.h2`
    font-size: 14px;
    line-height: 18px;
    color: ${COLORS.BLACK};
    margin-top: 16px;
  `,

  Content: styled.div`
    display: flex;
    flex-direction: column;
    margin-bottom: 16px;
    flex: 1;
    min-height: 70px;
  `,

  OptionContainer: styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 8px 12px;
    height: calc(100% - 65px);
    align-content: flex-end;

    @media (min-width: ${BREAKPOINTS[426]}px) {
      align-items: center;
    }
  `,

  StyledOption: styled(Option)<{ $isShortOption?: boolean }>`
    max-width: ${BREAKPOINTS[343]}px;
    margin: 0 auto;
    border-radius: 12px;
    padding: 16px 12px;

    &:not(:last-of-type) {
      margin-bottom: 12px;
    }

    ${({ $isShortOption }) =>
      $isShortOption &&
      css`
        margin: 0;
        max-width: 165px;
        height: fit-content;
      `}
  `,

  Value: styled.p`
    font-weight: 700;
    font-size: 14px;
    line-height: 18px;
    color: ${COLORS.BLACK};
    max-width: 250px;
  `,

  ButtonContainer: styled.div`
    margin-top: auto;
    padding-top: 16px;
    position: relative;
    background: rgba(239, 245, 247, 0.72);
    backdrop-filter: blur(12px);
    -webkit-backdrop-filter: blur(12px);

    &::before {
      content: '';
      position: absolute;
      left: 0;
      right: 0;
      top: -11px;
      height: 11px;
      background: linear-gradient(
        to bottom,
        rgba(239, 245, 247, 0),
        rgba(239, 245, 247, 0.72)
      );
      pointer-events: none;
    }
  `,
} as const
